import { getSpots, postSpot, postTablet } from "./protected";
import { posterListSpots, posterListTablets } from "./poster";
import { asArray, asPosterInner } from "../poster/response";

/**
 * Синхронизация всех точек Poster в локальную API (идемпотентно).
 * @param {string} posterToken
 * @param {string} accountUrl
 */
export async function syncAllPosterSpotsToDb(posterToken, accountUrl) {
  const raw = await posterListSpots(posterToken);
  const innerData = asPosterInner(raw);
  const list = asArray(innerData);
  for (const s of list) {
    if (s == null) continue;
    const spotId = s.spot_id;
    if (spotId == null) continue;
    const name = s.name != null ? String(s.name) : "";
    const address = s.address != null ? String(s.address).trim() : "";
    const body = { spot_id: Number(spotId), name };
    if (address) {
      body.address = address;
    }
    try {
      await postSpot(accountUrl, body);
    } catch (e) {
      if (/** @type {any} */(e).response?.status === 409) {
        /* уже есть */
      } else {
        throw e;
      }
    }
  }
  return getSpots(accountUrl);
}

/**
 * Планшеты Poster для точки: синк точек → find local spot → create tablets.
 * @param {string} posterToken
 * @param {string} accountUrl
 * @param {string|number} posterSpotId
 */
export async function syncTabletsForPosterSpot(
  posterToken,
  accountUrl,
  posterSpotId,
) {
  await syncAllPosterSpotsToDb(posterToken, accountUrl);
  const afterSpots = await getSpots(accountUrl);
  const list = asArray(afterSpots);
  const sid = String(posterSpotId);
  const local = list.find(
    (d) => d && String(/** @type {any} */(d).spot_id) === sid,
  );
  if (!local || !/** @type {any} */(local)._id) {
    throw new Error("Локальная точка не найдена. Проверьте account_url и синк.");
  }
  const mongoSpotId = /** @type {any} */(local)._id;
  const rawT = await posterListTablets(posterToken);
  const innerT = asPosterInner(rawT);
  const allTablets = asArray(innerT);
  const forSpot = allTablets.filter(
    (t) => t && String(/** @type {any} */(t).spot_id) === sid,
  );
  for (const t of forSpot) {
    const tabletId = parseInt(
      String(/** @type {any} */(t).tablet_id),
      10,
    );
    if (Number.isNaN(tabletId)) continue;
    const name = /** @type {any} */(t).tablet_name || /** @type {any} */(t).name || "";
    try {
      await postTablet(accountUrl, {
        tablet_id: tabletId,
        name: String(name),
        spot_id: mongoSpotId,
      });
    } catch (e) {
      if (/** @type {any} */(e).response?.status === 409) {
        /* уже есть */
      } else {
        throw e;
      }
    }
  }
  return { localSpot: local, tablets: forSpot };
}
